import { render, staticRenderFns } from "./fl223-notice-card.vue?vue&type=template&id=6ef03c28&scoped=true&"
import script from "./fl223-notice-card.vue?vue&type=script&lang=js&"
export * from "./fl223-notice-card.vue?vue&type=script&lang=js&"
import style0 from "./fl223-notice-card.vue?vue&type=style&index=0&id=6ef03c28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef03c28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ef03c28')) {
      api.createRecord('6ef03c28', component.options)
    } else {
      api.reload('6ef03c28', component.options)
    }
    module.hot.accept("./fl223-notice-card.vue?vue&type=template&id=6ef03c28&scoped=true&", function () {
      api.rerender('6ef03c28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/fl223-notices/partials/fl223-notice-card.vue"
export default component.exports